import { render } from "./WCInstructionsModal.vue?vue&type=template&id=e8f69f70"
import script from "./WCInstructionsModal.vue?vue&type=script&lang=js"
export * from "./WCInstructionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__